import React from "react";
import styled from "styled-components";

const StreamerOptions = ({ onOptionSelect }) => (
  <Wrapper>
    <Prompt>¿Vas a retransmitir la partida?</Prompt>
    <BtnRow>
      <OptionBtn onClick={() => onOptionSelect("directo")}>
        En directo
      </OptionBtn>
      <OptionBtn onClick={() => onOptionSelect("diferido")}>
        En diferido
      </OptionBtn>
      <OptionBtn onClick={() => onOptionSelect("transmitido")}>
        Ya transmitida
      </OptionBtn>
    </BtnRow>
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const Prompt = styled.p`
  font-family: var(--v-font-body);
  font-size: 13px;
  color: var(--v-fg);
  margin: 0;
`;

const BtnRow = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
`;

const OptionBtn = styled.button`
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: var(--v-fg);
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 0.5rem 1rem;
  border-radius: 24px;
  cursor: pointer;
  transition: background var(--v-transition), border-color var(--v-transition);

  &:hover {
    background: rgba(255, 255, 255, 0.04);
    border-color: var(--v-mint);
    color: var(--v-mint);
  }
`;

export default StreamerOptions;
